"use strict";
var INIT_ACTION = "@ngrx/store/init";
var detectDate = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/;
//correctly parse dates from local storage
exports.dateReviver = function (key, value) {
    if (typeof value === 'string' && (detectDate.test(value))) {
        return new Date(value);
    }
    return value;
};
var validateStateKeys = function (keys) {
    return keys.map(function (key) {
        var attr = key;
        if (typeof key == 'object') {
            attr = Object.keys(key)[0];
        }
        if (typeof (attr) !== 'string') {
            throw new TypeError("localStorageSync Unknown Parameter Type: "
                + ("Expected type of string, got " + typeof attr));
        }
        return key;
    });
};
exports.rehydrateApplicationState = function (keys, storage) {
    return keys.reduce(function (acc, curr) {
        var key = curr;
        var reviver = exports.dateReviver;
        var deserialize = undefined;
        if (typeof key == 'object') {
            key = Object.keys(key)[0];
            // use the custom reviver function
            if (typeof curr[key] === 'function') {
                reviver = curr[key];
            }
            else {
                // use custom reviver function if available
                if (curr[key].reviver) {
                    reviver = curr[key].reviver;
                }
                // use custom serialize function if available
                if (curr[key].deserialize) {
                    deserialize = curr[key].deserialize;
                }
            }
        }
        var stateSlice = storage.getItem(key);
        if (stateSlice) {
            var raw = JSON.parse(stateSlice, reviver);
            return Object.assign({}, acc, (_a = {}, _a[key] = deserialize ? deserialize(raw) : raw, _a));
        }
        return acc;
        var _a;
    }, {});
};
exports.syncStateUpdate = function (state, keys, storage) {
    keys.forEach(function (key) {
        var stateSlice = state[key];
        var replacer = undefined;
        var space = undefined;
        if (typeof key == 'object') {
            var name_1 = Object.keys(key)[0];
            stateSlice = state[name_1];
            if (key[name_1]) {
                // use serialize function if specified.
                if (key[name_1].serialize) {
                    stateSlice = key[name_1].serialize(stateSlice);
                }
                else {
                    var filter = undefined;
                    if (key[name_1].reduce) {
                        filter = key[name_1];
                    }
                    else if (key[name_1].filter) {
                        filter = key[name_1].filter;
                    }
                    if (filter) {
                        stateSlice = filter.reduce(function (memo, attr) {
                            memo[attr] = stateSlice[attr];
                            return memo;
                        }, {});
                    }
                }
                /*
                    Replacer and space arguments to pass to JSON.stringify.
                    If these fields don't exist, undefined will be passed.
                */
                replacer = key[name_1].replacer;
                space = key[name_1].space;
            }
            key = name_1;
        }
        if (typeof (stateSlice) !== 'undefined') {
            try {
                storage.setItem(key, typeof stateSlice == 'string' ? stateSlice : JSON.stringify(stateSlice, replacer, space));
            }
            catch (e) {
                console.warn('Unable to save state to localStorage:', e);
            }
        }
    });
};
exports.localStorageSync = function (keys, rehydrate, storage) {
    if (rehydrate === void 0) { rehydrate = false; }
    if (storage === void 0) { storage = localStorage; }
    return function (reducer) {
        var stateKeys = validateStateKeys(keys);
        var rehydratedState = rehydrate ? exports.rehydrateApplicationState(stateKeys, storage) : undefined;
        return function (state, action) {
            if (state === void 0) { state = rehydratedState; }
            /*
             Handle case where state is rehydrated AND initial state is supplied.
             Any additional state supplied will override rehydrated state for the given key.
             */
            if (action.type === INIT_ACTION && rehydratedState) {
                state = Object.assign({}, state, rehydratedState);
            }
            var nextState = reducer(state, action);
            exports.syncStateUpdate(nextState, stateKeys, storage);
            return nextState;
        };
    };
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngrx-store-localstorage/dist/index.js
// module id = 62z6
// module chunks = 4